angular.module('lsnBase.models')
  .service('strLowerCaseModelFilter', [function(){
    return function(val)
    {
      if (!angular.isString(val)) {
        return val;
      }
      return val.toLowerCase();
    };
  }]);